import {Button, Modal} from "react-bootstrap";
import {Dispatch, SetStateAction, useCallback, useContext, useEffect, useMemo, useState} from "react";
import {AppContext} from "../../appContext/AppContext";
import {ReportAssignmentContext} from "../ReportAssignment";
import {Form, Formik} from "formik";
import {searchDepartments, singleAssignEvaluate} from "../services/reportAssignment";
import {CODE, CODE_SUCCESS} from "../../utils/Constant";
import {toast} from "react-toastify";
import {IconButtonSave} from "../../component/IconSvg";
import {TypeFormItem} from "../models/reportAssignment";
import ModalHeader from "../../component/ModalHeader";
import OctTable from "../../component/table/table-collapse-custom/OctTableCollapse";
import {useColumns} from "../columns/AssignEvaluation";
import {columnNamesTypeTableCollapse} from "@oceantech/oceantech-ui";
import TextField from "../../component/TextField";
import {localStorageItem} from "../../utils/LocalStorage";
import {KEY_LOCALSTORAGE} from "../../auth/core/_consts";
import {groupByDepartment} from "../ultis";


interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  type: TypeFormItem;
  setInitialValues: Dispatch<SetStateAction<any>>;
}

const AssignEvaluationDialog = (props: Props) => {
  const {show, onHide, initialValues, type} = props;
  const {setIsLoading} = useContext(AppContext);
  const {detailItem, setDetailItem} = useContext(ReportAssignmentContext);

  const [isView, setIsView] = useState<boolean>(false);
  const [listCriteria, setListCriteria] = useState<any[]>([]);
  const [listDepartment, setListDepartment] = useState<any[]>([]);

  const {org = ""} = localStorageItem.get(KEY_LOCALSTORAGE.ACCESS_TOKEN_DECODE)

  useEffect(() => {
    if (detailItem?.listCriteria) {
      setListCriteria(detailItem?.listCriteria || []);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues?.slipDto?.id, detailItem?.listCriteria]);

  const handleChangeRowInput = useCallback((index: number, option: any) => {
    if (!option?.id) {
      handleDeleteAssgin({ids: [listCriteria[index]?.id || ""].filter(Boolean)}).then(r => r);
    }
    setListCriteria((prev: any) => {
      const item = {...prev[index]};
      const newArray = [...prev];

      item.assign = option?.id;
      newArray[index] = item;

      return newArray;
    })
  }, [listCriteria]);

  const handleFormSubmit = async () => {
    try {
      setIsLoading(true);
      const payload = groupByDepartment(listCriteria);
      // const payload = [{
      //   assign: "d61d0e83-c83c-493e-bbf2-5662f2d15ebd",
      //   ids: listCriteria.map((item: any) => item.id),
      // }]

      const res = await Promise.allSettled(
        payload.map(singleAssignEvaluate)
      );
      const hasError = res.some(
        (item: any) => item.status === "rejected" || item.value.data?.code !== CODE_SUCCESS
      );
      if (hasError) {
        throw res.filter(
          (item: any) => item.status === "rejected" || item.value.data?.code !== CODE_SUCCESS
        );
      }
    } catch (error) {
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteAssgin = async (item: any) => {
    try {
      setIsLoading(true);
      const res = await singleAssignEvaluate(item);
      if (CODE.SUCCESS !== res.data?.code) {
        let errorMesage = res.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
      }
    } catch (error) {
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  const handleGetListDepartment = async () => {
    if (listDepartment.length > 0) {return;}
    try {
      const res = await searchDepartments({
        pageIndex: 1,
        pageSize: 9999,
        level: 2,
        orgId: org,
      });
      if (res.data?.code === CODE_SUCCESS) {
        setListDepartment(res.data?.data?.content || []);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const columns: columnNamesTypeTableCollapse[] = useColumns({
    isView,
    listDepartment,
    handleGetListDepartment,
    handleChangeRowInput,
  });

  return (
    <Modal
      centered
      show={show}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50"
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={handleFormSubmit}
      >
        {({ values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <ModalHeader onHide={onHide} title="Phân công đánh giá" />
            <Modal.Body className="spaces p-0 bg-white">
              <div className="">
                <div className="spaces px-10">
                  <TextField
                    label="Kế hoạch"
                    type="text"
                    name="name"
                    value={detailItem?.name || ''}
                    className="flex"
                    labelClassName="spaces mt-5 mr-5"
                    disabled
                  />
                </div>
                <div className="line-bottom"></div>
                <div className="mt-5">
                  <OctTable
                    noAction
                    data={listCriteria}
                    columns={columns}
                    nameChildren="subs"
                    setData={(value: any) => { }}
                    selectData={(value: any) => { }}
                    searchObject={{}}
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-start bg-white spaces py-6 pl-5">
              {!isView &&
                <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                  <IconButtonSave /> Lưu
                </Button>
              }
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default AssignEvaluationDialog;
